import React from "react";
import { Tooltip } from "antd";
import SalarySheetRow from "./SalarySheetRow";
import SalarySheetTotal from "./SalarySheetTotal";
import { sheetTotals } from "./riderLogic";

export default function SalarySheetTable({ riders, search, entryOf, change, submitting, submit }) {
  return (
    <div className="stl-scroll stl-scroll--sticky">
      <table className="stl-table">
        <thead>
          <tr>
            <th rowSpan={2} className="stl-sticky-start">
              Rider
            </th>
            <th rowSpan={2}>Orders</th>
            <th colSpan={3} className="stl-group stl-divide">
              From the day's orders
            </th>
            <th colSpan={4} className="stl-group stl-divide">
              Adjustments
            </th>
            <th colSpan={2} className="stl-group stl-divide">
              Day's cash
            </th>
            <th colSpan={2} className="stl-group stl-divide">
              Balance now
            </th>
            <th rowSpan={2} className="stl-sticky-end stl-left">
              Salary
            </th>
          </tr>
          <tr>
            <th className="stl-divide">Delivery charges</th>
            <th>Tips</th>
            <th>Surge</th>
            <th className="stl-divide">Incentive</th>
            <th>Special</th>
            <th>Correction</th>
            <th className="stl-left">Note</th>
            <th className="stl-divide">Collected</th>
            <th>
              <Tooltip title="Cash collected − salary. Red: the rider hands this to the office. Green: the office pays the rider.">
                <span className="stl-help">To admin</span>
              </Tooltip>
            </th>
            <th className="stl-divide">Cash in hand</th>
            <th>Charges owed</th>
          </tr>
        </thead>
        <tbody>
          {riders.length === 0 ? (
            <tr>
              <td colSpan={14} className="stl-no-match">
                No rider matches “{search.trim()}”.
              </td>
            </tr>
          ) : (
            riders.map((rider) => (
              <SalarySheetRow
                key={rider.id}
                rider={rider}
                entry={entryOf(rider)}
                onChange={(field, value) => change(rider, field, value)}
                saving={submitting === rider.id}
                onSubmit={() => submit(rider)}
              />
            ))
          )}
        </tbody>
        {riders.length > 0 && <SalarySheetTotal totals={sheetTotals(riders, entryOf)} />}
      </table>
    </div>
  );
}
